(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["od-blog-reference"] && !Shopify.designMode) return;
  try {
    
function initOdJournals(){document.querySelectorAll('.od-journal').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const input=root.querySelector('[data-od-search]'),form=root.querySelector('[data-od-search-form]'),cards=[...root.querySelectorAll('[data-od-card]')],empty=root.querySelector('[data-od-empty]'),filters=root.querySelector('[data-od-filters]');if(!input||!filters)return;filters.hidden=false;let category='';const normalize=s=>s.toLocaleLowerCase('it').normalize('NFD').replace(/[\u0300-\u036f]/g,'');function filter(){const query=normalize(input.value.trim());let count=0;cards.forEach(card=>{const show=(!category||card.dataset.category===category)&&normalize(card.dataset.search).includes(query);card.hidden=!show;if(show)count++});empty.hidden=count>0}input.addEventListener('input',filter);form.addEventListener('submit',event=>{event.preventDefault();filter();root.querySelector('.od-journal-list').scrollIntoView({block:'start',behavior:'instant'})});filters.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>{category=button.dataset.odCategory;filters.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));filter()}))})}initOdJournals();document.addEventListener('shopify:section:load',initOdJournals);

  } catch(e) { console.error(e); }
})();
})();
